import { ReactNode, useState } from "react";
import useDialogHooks from "../../../../../../../../Components/Dialog/dialog-hooks";
import { useDrawerHooks } from "../../../../../../../../Components/Drawer/drawer-hooks";
import HeaderMenuDrawer from "../../Drawer/HeaderMenuDrawer/headerMenuDrawer";
import { IMyOrdersHeaderProps } from "./myOrdersHeader";
import { VisitorPageContents } from "../../../../../visitorPage";
import SettingsDialog from "../../../../../../../../Components/Dialog/DialogContents/UserProfile/Settings/settingsDialog";

const useMyOrdersHeader = (props: IMyOrdersHeaderProps) => {
    const { logo, is_user, companyId, services, setContentType,onOpenReserveDialog } = props;
    const tableReservation = services?.reserve;
    const { open, onOpen, onClose } = useDialogHooks();
    const { openDrawer, onCloseDrawer, onOpenDrawer } = useDrawerHooks();
    const [dialogComponent, setDialogComponent] = useState<ReactNode>(<></>);
    const [drawercomponent, setDrawerComponent] = useState<ReactNode | null>(null);

    const onCloseHeaderDrawer = () => {
        setDrawerComponent(null);
        onCloseDrawer()
    };

     const onReserveDialog = () => {
        onCloseHeaderDrawer();
        onOpenReserveDialog()
    };

    const onOpenMenuDrawer = () => {
        setDrawerComponent(
            <HeaderMenuDrawer
                logo={logo}
                onClose={onCloseHeaderDrawer}
                active={VisitorPageContents.MY_ORDERS}
                companyId={companyId}
                setContentType={setContentType}
                is_user={is_user}
                tableReservation={tableReservation}
                onReserveTableDialog={onReserveDialog}
            />
        );
        onOpenDrawer()
    };

    const onOpenSettingDialog = () => {
        onOpen();
        setDialogComponent(<SettingsDialog onClose={onClose} />)
    };

    return {
        open,
        openDrawer,
        dialogComponent,
        drawercomponent,
        onClose,
        onOpenMenuDrawer,
        onOpenSettingDialog,
        onCloseHeaderDrawer,
    };
};

export default useMyOrdersHeader